import { Component, ReactNode } from 'react'

type LogFunctionType = (
    eventName: string,
    eventParams?: Record<string, unknown>
) => void

interface ErrorBoundaryProps {
    logFunction?: LogFunctionType
    children: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

class GetAppError extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true }
    }

    componentDidCatch(error: Error): void {
        if (this.props.logFunction) {
            this.props.logFunction('app_error', {
                description: `JavaScript Error: ${error.toString()}`,
            })
        }
    }

    render(): ReactNode {
        return this.props.children
    }
}

export { GetAppError }
